export default __webpack_public_path__ + "static/media/gradient.a56f7a94.svg";